import styles from './APIManagementSection.module.scss';
import { APINestedRoutes, AppRoutes } from 'src/types';
import { ChartLine, GearSix, Key } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import classNames from 'classnames';
import { useGetUser, useManageCreditAccountPageRightPanel } from 'src/hooks';
import { Button } from 'src/v2/commonComponents/Button';
import { useLocation } from 'react-router-dom';
import { MouseEvent, useCallback, useMemo } from 'react';

export const APIManagementSection = () => {
  const { isOpenTier } = useGetUser();
  const location = useLocation();
  const { activePanelView, changeActivePanelView } =
    useManageCreditAccountPageRightPanel();

  const getRoute = useCallback((nestedRoute: string) => {
    return `${AppRoutes.ADD_ON}/${nestedRoute}`;
  }, []);

  const buttons = useMemo(
    () => [
      {
        disabled: false,
        title: 'Settings',
        route: getRoute(APINestedRoutes.CREDITS),
        icon: <GearSix size={SVG_SIZE_M} />,
        isVisible: true,
        additionalActivePaths: [AppRoutes.ADD_ON],
      },
      {
        disabled: false,
        title: 'API keys',
        route: getRoute(APINestedRoutes.API_KEYS),
        icon: <Key size={SVG_SIZE_M} />,
        isVisible: true,
      },
      {
        disabled: isOpenTier,
        title: 'Credit usage',
        route: getRoute(APINestedRoutes.API_USAGE),
        icon: <ChartLine size={SVG_SIZE_M} />,
        isVisible: true,
      },
    ],
    [getRoute, isOpenTier],
  );

  const handleClick = (
    e: MouseEvent<HTMLAnchorElement>,
    item: (typeof buttons)[number],
  ) => {
    if (item.disabled) {
      e.preventDefault();
      return;
    }

    if (
      item.route !== `${AppRoutes.ADD_ON}/${APINestedRoutes.CREDITS}` &&
      !!activePanelView
    ) {
      changeActivePanelView(null);
    }
  };

  return (
    <div className={styles.sectionWrapper}>
      {buttons.map((item) => (
        <Button
          key={item.route}
          as="link"
          className={classNames(styles.menuLink, {
            [styles.active]:
              item.route.split('?')[0] === location.pathname ||
              (!!item.additionalActivePaths &&
                item.additionalActivePaths.includes(
                  location.pathname as AppRoutes,
                )),
            [styles.disabled]: item.disabled,
          })}
          to={item.route}
          onClick={(e) => handleClick(e, item)}
          color="transparent"
        >
          {item.icon}
          {item.title}
        </Button>
      ))}
    </div>
  );
};
